module.exports = __webpack_public_path__ + "img/ttf-main-828.a968518d.jpg";